/* WARNING: This file is auto-generated . Do not edit manually. */

import { DedicatedCloudRobot } from '../models/DedicatedCloudRobot';
import { DedicatedCloudUserLogoutPolicyEnum } from '../models/DedicatedCloudUserLogoutPolicyEnum';
import { DedicatedCloudFilerProfile } from '../models/DedicatedCloudFilerProfile';
import { DedicatedCloudObjectRight } from '../models/DedicatedCloudObjectRight';
import { DedicatedCloudRestorePoint } from '../models/DedicatedCloudRestorePoint';
import { DedicatedCloudTwoFAWhitelist } from '../models/DedicatedCloudTwoFAWhitelist';
import { DedicatedCloudHost } from '../models/DedicatedCloudHost';
import { DedicatedCloudUserAccessPolicyEnum } from '../models/DedicatedCloudUserAccessPolicyEnum';
import { DedicatedCloudHostProfile } from '../models/DedicatedCloudHostProfile';
import { DedicatedCloudTaskStateEnum } from '../models/DedicatedCloudTaskStateEnum';
import { DedicatedCloudAllowedNetwork } from '../models/DedicatedCloudAllowedNetwork';
import { DedicatedCloudBackupBackupDaysEnum } from '../models/DedicatedCloudBackupBackupDaysEnum';
import { DedicatedCloudSecurityOption } from '../models/DedicatedCloudSecurityOption';
import { DedicatedCloudDisasterRecoveryZertoProtectedVm } from '../models/DedicatedCloudDisasterRecoveryZertoProtectedVm';
import { DedicatedCloudHds } from '../models/DedicatedCloudHds';
import { DedicatedCloudCommercialRange } from '../models/DedicatedCloudCommercialRange';
import { DedicatedCloudRightUserObjectRightTypeEnum } from '../models/DedicatedCloudRightUserObjectRightTypeEnum';
import { DedicatedCloudBackupOptimizeProxies } from '../models/DedicatedCloudBackupOptimizeProxies';
import { DedicatedCloudPccStockProfile } from '../models/DedicatedCloudPccStockProfile';
import { DedicatedCloudBackupJob } from '../models/DedicatedCloudBackupJob';
import { DedicatedCloudHostStockProfile } from '../models/DedicatedCloudHostStockProfile';
import { DedicatedCloudVMEncryption } from '../models/DedicatedCloudVMEncryption';
import { DedicatedCloudDisasterRecoveryProfile } from '../models/DedicatedCloudDisasterRecoveryProfile';
import { DedicatedCloudBackupRepository } from '../models/DedicatedCloudBackupRepository';
import { ServiceTerminationFutureUseEnum } from '../models/ServiceTerminationFutureUseEnum';
import { DedicatedCloudRightNetworkRoleEnum } from '../models/DedicatedCloudRightNetworkRoleEnum';
import { DedicatedCloudPrivateGateway } from '../models/DedicatedCloudPrivateGateway';
import { VrackTask } from '../models/VrackTask';
import { DedicatedCloudFederationAccessNetwork } from '../models/DedicatedCloudFederationAccessNetwork';
import { DedicatedCloudOs } from '../models/DedicatedCloudOs';
import { DedicatedCloudVendorObjectTypeEnum } from '../models/DedicatedCloudVendorObjectTypeEnum';
import { DedicatedCloudOptionCompatibility } from '../models/DedicatedCloudOptionCompatibility';
import { DedicatedCloudBackupOfferTypeEnum } from '../models/DedicatedCloudBackupOfferTypeEnum';
import { ServiceTerminationReasonEnum } from '../models/ServiceTerminationReasonEnum';
import { DedicatedCloudFiler } from '../models/DedicatedCloudFiler';
import { DedicatedCloudVrops } from '../models/DedicatedCloudVrops';
import { DedicatedCloudFederation } from '../models/DedicatedCloudFederation';
import { ServicesService } from '../models/ServicesService';
import { DedicatedCloudServicePack } from '../models/DedicatedCloudServicePack';
import { DedicatedCloudBackup } from '../models/DedicatedCloudBackup';
import { DedicatedCloudFilerNodeTypeEnum } from '../models/DedicatedCloudFilerNodeTypeEnum';
import { DedicatedCloudFilerHourlyConsumption } from '../models/DedicatedCloudFilerHourlyConsumption';
import { DedicatedCloudDatacenter } from '../models/DedicatedCloudDatacenter';
import { DedicatedCloudVendor } from '../models/DedicatedCloudVendor';
import { DedicatedCloudSecurityOptionSecurityOptionEnum } from '../models/DedicatedCloudSecurityOptionSecurityOptionEnum';
import { DedicatedCloudRight } from '../models/DedicatedCloudRight';
import { DedicatedCloudPccZone } from '../models/DedicatedCloudPccZone';
import { DedicatedCloudHostHourlyConsumption } from '../models/DedicatedCloudHostHourlyConsumption';
import { DedicatedCloudResourceNewPrices } from '../models/DedicatedCloudResourceNewPrices';
import { DedicatedCloudIp } from '../models/DedicatedCloudIp';
import { DedicatedCloudVcenter } from '../models/DedicatedCloudVcenter';
import { DedicatedCloudVlan } from '../models/DedicatedCloudVlan';
import { DedicatedCloudHcx } from '../models/DedicatedCloudHcx';
import { DedicatedCloudNsxt } from '../models/DedicatedCloudNsxt';
import { DedicatedCloudVMEncryptionAccessNetwork } from '../models/DedicatedCloudVMEncryptionAccessNetwork';
import { DedicatedCloudUser } from '../models/DedicatedCloudUser';
import { DedicatedCloudCapabilities } from '../models/DedicatedCloudCapabilities';
import { VrackDedicatedCloud } from '../models/VrackDedicatedCloud';
import { DedicatedCloudHostResilience } from '../models/DedicatedCloudHostResilience';
import { DedicatedCloudIpDetails } from '../models/DedicatedCloudIpDetails';
import { DedicatedCloudRightVmNetworkRoleEnum } from '../models/DedicatedCloudRightVmNetworkRoleEnum';
import { DedicatedCloudDedicatedCloud } from '../models/DedicatedCloudDedicatedCloud';
import { DedicatedCloudHostLocation } from '../models/DedicatedCloudHostLocation';
import { DedicatedCloudSecurityOptionDependenciesTree } from '../models/DedicatedCloudSecurityOptionDependenciesTree';
import { DedicatedCloudReleaseEnum } from '../models/DedicatedCloudReleaseEnum';
import { DedicatedCloudPciDss } from '../models/DedicatedCloudPciDss';
import { DedicatedCloudNsx } from '../models/DedicatedCloudNsx';
import { DedicatedCloudHipaa } from '../models/DedicatedCloudHipaa';
import { DedicatedCloudVm } from '../models/DedicatedCloudVm';
import { DedicatedCloudPasswordPolicy } from '../models/DedicatedCloudPasswordPolicy';
import { DedicatedCloudBackupBackupCapabilities } from '../models/DedicatedCloudBackupBackupCapabilities';
import { DedicatedCloudIpCountriesEnum } from '../models/DedicatedCloudIpCountriesEnum';
import { DedicatedCloudSecurityOptionCompatibilityMatrixEntry } from '../models/DedicatedCloudSecurityOptionCompatibilityMatrixEntry';
import { DedicatedCloudServicePackStatus } from '../models/DedicatedCloudServicePackStatus';
import { DedicatedCloudVendorOvhId } from '../models/DedicatedCloudVendorOvhId';
import { DedicatedCloudRightRightEnum } from '../models/DedicatedCloudRightRightEnum';
import { DedicatedCloudZpoolStockProfile } from '../models/DedicatedCloudZpoolStockProfile';
import { DedicatedCloudFilerLocation } from '../models/DedicatedCloudFilerLocation';
import { DedicatedCloudCluster } from '../models/DedicatedCloudCluster';
import { DedicatedCloudCompliantRanges } from '../models/DedicatedCloudCompliantRanges';
import { DedicatedCloudTask } from '../models/DedicatedCloudTask';
import { DedicatedCloudMetricsToken } from '../models/DedicatedCloudMetricsToken';
import OVHBase from '../ovh';

class DedicatedCloudHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List available services */
  list = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dedicatedCloud');
  };

  /** List of commercial Ranges available in a Dedicated Cloud */
  listCommercialRange = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dedicatedCloud/commercialRange');
  };

  /** Get this object properties */
  getCommercialRangeByCommercialRangeName = (
    commercialRangeName: string
  ): Promise<DedicatedCloudCommercialRange> => {
    return this.ovh.request('GET', `/dedicatedCloud/commercialRange/${commercialRangeName}`);
  };

  /** List of locations available in a Dedicated Cloud */
  listLocation = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dedicatedCloud/location');
  };

  /** Get this object properties */
  getLocationByPccZone = (pccZone: string): Promise<DedicatedCloudPccZone> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}`);
  };

  /** Offered host profile */
  getLocationHostProfileByPccZone = (pccZone: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/hostProfile`);
  };

  /** Get this object properties */
  getLocationHostProfileByPccZoneAndId = (
    id: number,
    pccZone: string
  ): Promise<DedicatedCloudHostProfile> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/hostProfile/${id}`);
  };

  /** Offered hypervisor version */
  getLocationHypervisorByPccZone = (pccZone: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/hypervisor`);
  };

  /** Get this object properties */
  getLocationHypervisorByPccZoneAndShortName = (
    pccZone: string,
    shortName: string
  ): Promise<DedicatedCloudOs> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/hypervisor/${shortName}`);
  };

  /** Available host stock */
  getLocationStockHostByPccZone = (pccZone: string): Promise<DedicatedCloudHostStockProfile[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/stock/host`);
  };

  /** Available PCC stock */
  getLocationStockPccByPccZone = (pccZone: string): Promise<DedicatedCloudPccStockProfile[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/stock/pcc`);
  };

  /** Available zpool stock */
  getLocationStockZpoolByPccZone = (
    pccZone: string
  ): Promise<DedicatedCloudZpoolStockProfile[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/location/${pccZone}/stock/zpool`);
  };

  /** Get this object properties */
  getByServiceName = (serviceName: string): Promise<DedicatedCloudDedicatedCloud> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}`);
  };

  /** Alter this object properties */
  updateByServiceName = (
    serviceName: string,
    body: DedicatedCloudDedicatedCloud
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('PUT', `/dedicatedCloud/${serviceName}`, body);
  };

  /** Networks allowed to access to this Dedicated Cloud management interface */
  getAllowedNetworkByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/allowedNetwork`);
  };

  /** Create a new Allowed network for your dedicatedCloud */
  createAllowedNetworkByServiceName = (
    serviceName: string,
    body: { description?: string; network: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/allowedNetwork`, body);
  };

  /** Remove this network from your Dedicated Cloud */
  deleteAllowedNetworkByServiceNameAndNetworkAccessId = (
    networkAccessId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'DELETE',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}`
    );
  };

  /** Get this object properties */
  getAllowedNetworkByServiceNameAndNetworkAccessId = (
    networkAccessId: number,
    serviceName: string
  ): Promise<DedicatedCloudAllowedNetwork> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}`
    );
  };

  /** Alter this object properties */
  updateAllowedNetworkByServiceNameAndNetworkAccessId = (
    networkAccessId: number,
    serviceName: string,
    body: DedicatedCloudAllowedNetwork
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'PUT',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}`,
      body
    );
  };

  /** Tasks associated with this allowed network */
  getAllowedNetworkTaskByServiceNameAndNetworkAccessId = (
    networkAccessId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}/task`
    );
  };

  /** Get this object properties */
  getAllowedNetworkTaskByServiceNameAndNetworkAccessIdAndTaskId = (
    networkAccessId: number,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}/task/${taskId}`
    );
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateAllowedNetworkTaskMaintenanceExecutionDateByServiceNameAndNetworkAccessIdAndTaskId = (
    networkAccessId: number,
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postAllowedNetworkTaskResetTaskStateByServiceNameAndNetworkAccessIdAndTaskId = (
    networkAccessId: number,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/allowedNetwork/${networkAccessId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Backup repositories associated with this Pcc */
  getBackupRepositoryByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/backupRepository`);
  };

  /** Get this object properties */
  getBackupRepositoryByServiceNameAndRepositoryId = (
    repositoryId: number,
    serviceName: string
  ): Promise<DedicatedCloudBackupRepository> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/backupRepository/${repositoryId}`
    );
  };

  /** Get this object properties */
  getCapabilitiesByServiceName = (serviceName: string): Promise<DedicatedCloudCapabilities> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/capabilities`);
  };

  /** Launch a contact change procedure */
  launchChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/changeContact`, body);
  };

  /** Update this Dedicated Cloud properties. */
  updateChangePropertiesByServiceName = (
    serviceName: string,
    body: {
      description?: string;
      sslV3?: boolean;
      userAccessPolicy?: DedicatedCloudUserAccessPolicyEnum;
      userLimitConcurrentSession?: number;
      userLogoutPolicy?: DedicatedCloudUserLogoutPolicyEnum;
      userSessionTimeout?: number;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/changeProperties`, body);
  };

  /** Get the name of the commercial ranges compliant with your Dedicated Cloud */
  getCommercialRangeComplianceByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudCompliantRanges[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/commercialRange/compliance`);
  };

  /** Get the name of the commercial ranges orderable for your Dedicated Cloud */
  getCommercialRangeOrderableByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/commercialRange/orderable`);
  };

  /** Confirm termination of your service */
  confirmTerminationByServiceName = (
    serviceName: string,
    body: {
      commentary?: string;
      futureUse?: ServiceTerminationFutureUseEnum;
      reason?: ServiceTerminationReasonEnum;
      token: string;
    }
  ): Promise<string> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/confirmTermination`, body);
  };

  /** Datacenters associated with this Dedicated Cloud */
  getDatacenterByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/datacenter`);
  };

  /** Add a new Datacenter in your Dedicated Cloud */
  addDatacenterByServiceName = (
    serviceName: string,
    body: { commercialRangeName: string; vrackName?: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/datacenter`, body);
  };

  /** Remove this Datacenter from your Dedicated Cloud. (It has to be empty in order to be removable) */
  deleteDatacenterByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('DELETE', `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}`);
  };

  /** Get this object properties */
  getDatacenterByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudDatacenter> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}`);
  };

  /** Alter this object properties */
  updateDatacenterByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: DedicatedCloudDatacenter
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'PUT',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}`,
      body
    );
  };

  /** Get this object properties */
  getDatacenterBackupByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudBackup> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup`
    );
  };

  /** Restores the last restore points for each backup located in the given backup repository to the given Datacenter */
  postDatacenterBackupBatchRestoreByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { backupJobName?: string; backupRepositoryName: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/batchRestore`,
      body
    );
  };

  /** Generates recommendation for Backup Proxies optimization */
  getDatacenterBackupCanOptimizeProxiesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudBackupOptimizeProxies> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/canOptimizeProxies`
    );
  };

  /** Edit the backup on a Dedicated Cloud */
  updateDatacenterBackupChangePropertiesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: {
      backupDurationInReport: boolean;
      backupOffer: DedicatedCloudBackupOfferTypeEnum;
      backupSizeInReport: boolean;
      diskSizeInReport: boolean;
      fullDayInReport: boolean;
      mailAddress?: string;
      restorePointInReport: boolean;
      scheduleHour?: Date;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/changeProperties`,
      body
    );
  };

  /** Disable backup solution on a Dedicated Cloud */
  disableDatacenterBackupByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/disable`
    );
  };

  /** Enable backup solution on a Dedicated Cloud */
  enableDatacenterBackupByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { backupOffer?: DedicatedCloudBackupOfferTypeEnum }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/enable`,
      body
    );
  };

  /** Generates an email report with all the backups, their last restore point, their size and their location */
  postDatacenterBackupGenerateReportByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/generateReport`
    );
  };

  /** List backup offer capabilities */
  listDatacenterBackupOfferCapabilitiesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudBackupBackupCapabilities[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/offerCapabilities`
    );
  };

  /** Optimizes number of Backup Proxies required for given Datacenter */
  postDatacenterBackupOptimizeProxiesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backup/optimizeProxies`
    );
  };

  /** Backup repositories associated with this Datacenter */
  getDatacenterBackupRepositoryByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backupRepository`
    );
  };

  /** Get this object properties */
  getDatacenterBackupRepositoryByServiceNameAndDatacenterIdAndRepositoryId = (
    datacenterId: number,
    repositoryId: number,
    serviceName: string
  ): Promise<DedicatedCloudBackupRepository> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/backupRepository/${repositoryId}`
    );
  };

  /** Check whether your backup jobs are correctly set in your current datacenter, use this when your virtual machines have been migrated through another datacenter */
  checkDatacenterBackupJobsByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/checkBackupJobs`
    );
  };

  /** Clusters associated with this Datacenter */
  getDatacenterClusterByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/cluster`
    );
  };

  /** Get this object properties */
  getDatacenterClusterByServiceNameAndDatacenterIdAndId = (
    datacenterId: number,
    id: number,
    serviceName: string
  ): Promise<DedicatedCloudCluster> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/cluster/${id}`
    );
  };

  /** Disable Zerto */
  disableDatacenterDisasterRecoveryZertoByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { secondaryDatacenterId: number; secondaryServiceName: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/disable`,
      body
    );
  };

  /** Enable Zerto replication between 2 OVH dedicated Clouds */
  enableDatacenterDisasterRecoveryZertoByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: {
      primaryEndpointIp: string;
      secondaryDatacenterId: number;
      secondaryEndpointIp: string;
      secondaryServiceName: string;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/enable`,
      body
    );
  };

  /** Finish migrating Zerto option to this datacenter */
  postDatacenterDisasterRecoveryZertoEndMigrationByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/endMigration`
    );
  };

  /** Start migrating Zerto option to this datacenter */
  postDatacenterDisasterRecoveryZertoStartMigrationByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/startMigration`
    );
  };

  /** Get the current state of Zerto deployment on your dedicated Cloud. */
  getDatacenterDisasterRecoveryZertoStatusByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudDisasterRecoveryProfile> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/status`
    );
  };

  /** Get the list of VMs protected by Zerto for a specific month on your dedicated Cloud. */
  getDatacenterDisasterRecoveryZertoUsageReportByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudDisasterRecoveryZertoProtectedVm[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zerto/usageReport`
    );
  };

  /** Configure vpn between your OVH Dedicated Cloud and your onsite infrastructure */
  postDatacenterDisasterRecoveryZertoSingleConfigureVpnByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: {
      preSharedKey: string;
      remoteEndpointInternalIp: string;
      remoteEndpointPublicIp: string;
      remoteVraNetwork?: string;
      remoteZvmInternalIp: string;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zertoSingle/configureVpn`,
      body
    );
  };

  /** Get the default localVraNetwork subnet suggested by OVH */
  getDatacenterDisasterRecoveryZertoSingleDefaultLocalVraNetworkByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zertoSingle/defaultLocalVraNetwork`
    );
  };

  /** Disable Single site Zerto */
  disableDatacenterDisasterRecoveryZertoSingleByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zertoSingle/disable`
    );
  };

  /** Enable Zerto replication between your OVH Dedicated Cloud and your onsite infrastructure */
  enableDatacenterDisasterRecoveryZertoSingleByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { localVraNetwork: string; ovhEndpointIp: string; remoteVraNetwork: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zertoSingle/enable`,
      body
    );
  };

  /** Request a pairing token in order to link your OVHcloud Zerto Virtual Manager to your local one */
  postDatacenterDisasterRecoveryZertoSingleRequestPairingTokenByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/disasterRecovery/zertoSingle/requestPairingToken`
    );
  };

  /** Filers associated with this Datacenter */
  getDatacenterFilerByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer`
    );
  };

  /** Get this object properties */
  getDatacenterFilerByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFiler> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}`
    );
  };

  /** Check if filer on your Dedicated Cloud is capable of converting to global */
  checkDatacenterFilerGlobalCompatibleByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/checkGlobalCompatible`
    );
  };

  /** Change the filer type to global on your Dedicated Cloud. */
  updateDatacenterFilerConvertToGlobalByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/convertToGlobal`
    );
  };

  /** Hourly consumption associated with this Filer */
  getDatacenterFilerHourlyConsumptionByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFilerHourlyConsumption> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/hourlyConsumption`
    );
  };

  /** Location of the Filer */
  getDatacenterFilerLocationByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFilerLocation> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/location`
    );
  };

  /** Remove the filer from your Dedicated Cloud. */
  postDatacenterFilerRemoveByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/remove`
    );
  };

  /** Tasks associated with this Filer */
  getDatacenterFilerTaskByServiceNameAndDatacenterIdAndFilerId = (
    datacenterId: number,
    filerId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/task`
    );
  };

  /** Get this object properties */
  getDatacenterFilerTaskByServiceNameAndDatacenterIdAndFilerIdAndTaskId = (
    datacenterId: number,
    filerId: number,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/task/${taskId}`
    );
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateDatacenterFilerTaskMaintenanceExecutionDateByServiceNameAndDatacenterIdAndFilerIdAndTaskId =
    (
      datacenterId: number,
      filerId: number,
      serviceName: string,
      taskId: number,
      body: { executionDate: Date }
    ): Promise<DedicatedCloudTask> => {
      return this.ovh.request(
        'POST',
        `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/task/${taskId}/changeMaintenanceExecutionDate`,
        body
      );
    };

  /** Restart task in error. */
  postDatacenterFilerTaskResetTaskStateByServiceNameAndDatacenterIdAndFilerIdAndTaskId = (
    datacenterId: number,
    filerId: number,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/filer/${filerId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Hosts associated with this Datacenter */
  getDatacenterHostByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host`
    );
  };

  /** Get this object properties */
  getDatacenterHostByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudHost> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}`
    );
  };

  /** Add a spare host to your Dedicated Cloud. */
  addDatacenterHostHostSpareByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/addHostSpare`,
      body
    );
  };

  /** Hourly consumption associated with this host. */
  getDatacenterHostHourlyConsumptionByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudHostHourlyConsumption> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/hourlyConsumption`
    );
  };

  /** Location of the host */
  getDatacenterHostLocationByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudHostLocation> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/location`
    );
  };

  /** Remove the host from your Dedicated Cloud. */
  postDatacenterHostRemoveByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/remove`
    );
  };

  /** Get this object properties */
  getDatacenterHostResilienceByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudHostResilience> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/resilience`
    );
  };

  /** Check if resilience test can be performed */
  checkDatacenterHostResilienceCanBeEnabledByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/resilience/canBeEnabled`
    );
  };

  /** Disable resilience test (reconnect the network of your host) */
  disableDatacenterHostResilienceByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/resilience/disable`
    );
  };

  /** Enable resilience test (disconnnect the network of your host) */
  enableDatacenterHostResilienceByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string,
    body: { duration?: number }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/resilience/enable`,
      body
    );
  };

  /** Tasks associated with this Host */
  getDatacenterHostTaskByServiceNameAndDatacenterIdAndHostId = (
    datacenterId: number,
    hostId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/task`
    );
  };

  /** Get this object properties */
  getDatacenterHostTaskByServiceNameAndDatacenterIdAndHostIdAndTaskId = (
    datacenterId: number,
    hostId: number,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/task/${taskId}`
    );
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateDatacenterHostTaskMaintenanceExecutionDateByServiceNameAndDatacenterIdAndHostIdAndTaskId = (
    datacenterId: number,
    hostId: number,
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postDatacenterHostTaskResetTaskStateByServiceNameAndDatacenterIdAndHostIdAndTaskId = (
    datacenterId: number,
    hostId: number,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/host/${hostId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Order a new hourly Filer in a given Datacenter */
  postDatacenterOrderNewFilerHourlyByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { name: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/orderNewFilerHourly`,
      body
    );
  };

  /** Order a new hourly Host in a given Datacenter */
  postDatacenterOrderNewHostHourlyByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { name: string; vmwareClusterId?: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/orderNewHostHourly`,
      body
    );
  };

  /** List available filers in a given Dedicated Cloud Datacenter */
  listDatacenterOrderableFilerProfilesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudFilerProfile[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/orderableFilerProfiles`
    );
  };

  /** List available hosts in a given Dedicated Cloud Datacenter */
  listDatacenterOrderableHostProfilesByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudHostProfile[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/orderableHostProfiles`
    );
  };

  /** Get this object properties */
  getDatacenterPrivateGatewayByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudPrivateGateway> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/privateGateway`
    );
  };

  /** Remove the private gateway in your Dedicated Cloud and open public access. */
  postDatacenterPrivateGatewayDisableByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/privateGateway/disable`
    );
  };

  /** Deploy a private gateway on your Dedicated Cloud to block all public access */
  postDatacenterPrivateGatewayEnableByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string,
    body: { ip: string; netmask: string; portgroup: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/privateGateway/enable`,
      body
    );
  };

  /** Tasks associated with this Datacenter */
  getDatacenterTaskByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/task`
    );
  };

  /** Get this object properties */
  getDatacenterTaskByServiceNameAndDatacenterIdAndTaskId = (
    datacenterId: number,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/task/${taskId}`
    );
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateDatacenterTaskMaintenanceExecutionDateByServiceNameAndDatacenterIdAndTaskId = (
    datacenterId: number,
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postDatacenterTaskResetTaskStateByServiceNameAndDatacenterIdAndTaskId = (
    datacenterId: number,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Virtual machiness associated with this Datacenter */
  getDatacenterVmByServiceNameAndDatacenterId = (
    datacenterId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm`);
  };

  /** Get this object properties */
  getDatacenterVmByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number
  ): Promise<DedicatedCloudVm> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}`
    );
  };

  /** Get this object properties */
  getDatacenterVmBackupJobByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number
  ): Promise<DedicatedCloudBackupJob> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob`
    );
  };

  /** Edit a backup job */
  updateDatacenterVmBackupJobByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { backupDays: DedicatedCloudBackupBackupDaysEnum[] }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob`,
      body
    );
  };

  /** Disable backup solution on this virtual Machine */
  disableDatacenterVmBackupJobByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob/disable`
    );
  };

  /** Enable backup solution on this virtual Machine */
  enableDatacenterVmBackupJobByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { backupDays: DedicatedCloudBackupBackupDaysEnum[] }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob/enable`,
      body
    );
  };

  /** Restore point associated to this Backup Job */
  getDatacenterVmBackupJobRestorePointsByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob/restorePoints`
    );
  };

  /** Get this object properties */
  getDatacenterVmBackupJobRestorePointsByServiceNameAndDatacenterIdAndVmIdAndRestorePointId = (
    datacenterId: number,
    restorePointId: number,
    serviceName: string,
    vmId: number
  ): Promise<DedicatedCloudRestorePoint> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob/restorePoints/${restorePointId}`
    );
  };

  /** Restore this restore point */
  postDatacenterVmBackupJobRestorePointsRestoreByServiceNameAndDatacenterIdAndVmIdAndRestorePointId =
    (
      datacenterId: number,
      restorePointId: number,
      serviceName: string,
      vmId: number,
      body: { filerId: number }
    ): Promise<DedicatedCloudTask> => {
      return this.ovh.request(
        'POST',
        `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/backupJob/restorePoints/${restorePointId}/restore`,
        body
      );
    };

  /** Disable backup on this virtual Machine */
  disableDatacenterVmBackupByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/disableBackup`
    );
  };

  /** Disable Carp on Virtual Machine */
  disableDatacenterVmCarpByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { macAddress: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/disableCarp`,
      body
    );
  };

  /** Edit backup on this virtual Machine */
  updateDatacenterVmBackupByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { backupDays: DedicatedCloudBackupBackupDaysEnum[] }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/editBackup`,
      body
    );
  };

  /** Enable backup on this virtual Machine */
  enableDatacenterVmBackupByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { backupDays: DedicatedCloudBackupBackupDaysEnum[] }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/enableBackup`,
      body
    );
  };

  /** Enable Carp on Virtual Machine */
  enableDatacenterVmCarpByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { macAddress: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/enableCarp`,
      body
    );
  };

  /** Restore this restore point */
  postDatacenterVmRestoreBackupByServiceNameAndDatacenterIdAndVmId = (
    datacenterId: number,
    serviceName: string,
    vmId: number,
    body: { filerId: number; restorePointId: number }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/datacenter/${datacenterId}/vm/${vmId}/restoreBackup`,
      body
    );
  };

  /** Get this object properties */
  getFederationByServiceName = (serviceName: string): Promise<DedicatedCloudFederation> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/federation`);
  };

  /** Active Directories linked to this Dedicated Cloud */
  getFederationActiveDirectoryByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/federation/activeDirectory`);
  };

  /** Add a new option user access */
  addFederationActiveDirectoryByServiceName = (
    serviceName: string,
    body: {
      baseDnForGroups: string;
      baseDnForUsers: string;
      description?: string;
      domainAlias: string;
      domainName: string;
      ip: string;
      ldapHostname?: string;
      ldapTcpPort?: number;
      noSsl?: boolean;
      password: string;
      sslThumbprint?: string;
      username: string;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory`,
      body
    );
  };

  /** Remove an option user access */
  deleteFederationActiveDirectoryByServiceNameAndActiveDirectoryId = (
    activeDirectoryId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'DELETE',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory/${activeDirectoryId}`
    );
  };

  /** Get this object properties */
  getFederationActiveDirectoryByServiceNameAndActiveDirectoryId = (
    activeDirectoryId: number,
    serviceName: string
  ): Promise<DedicatedCloudFederationAccessNetwork> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory/${activeDirectoryId}`
    );
  };

  /** Change Active Directory properties */
  updateFederationActiveDirectoryPropertiesByServiceNameAndActiveDirectoryId = (
    activeDirectoryId: number,
    serviceName: string,
    body: { description?: string; password: string; sslThumbprint?: string; username: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory/${activeDirectoryId}/changeProperties`,
      body
    );
  };

  /** Grant Active Directory group */
  postFederationActiveDirectoryGrantActiveDirectoryGroupByServiceNameAndActiveDirectoryId = (
    activeDirectoryId: number,
    serviceName: string,
    body: { groupName: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory/${activeDirectoryId}/grantActiveDirectoryGroup`,
      body
    );
  };

  /** Grant Active Directory user */
  postFederationActiveDirectoryGrantActiveDirectoryUserByServiceNameAndActiveDirectoryId = (
    activeDirectoryId: number,
    serviceName: string,
    body: { username: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/federation/activeDirectory/${activeDirectoryId}/grantActiveDirectoryUser`,
      body
    );
  };

  /** Filers mounted on all Datacenters of your Dedicated Cloud Vsphere */
  getFilerByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/filer`);
  };

  /** Get this object properties */
  getFilerByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFiler> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/filer/${filerId}`);
  };

  /** Check if filer on your Dedicated Cloud is capable of converting to global */
  checkFilerGlobalCompatibleByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/checkGlobalCompatible`
    );
  };

  /** Change the filer type to global on your Dedicated Cloud. */
  updateFilerConvertToGlobalByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/convertToGlobal`
    );
  };

  /** Hourly consumption associated with this Filer */
  getFilerHourlyConsumptionByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFilerHourlyConsumption> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/hourlyConsumption`
    );
  };

  /** Location of the Filer */
  getFilerLocationByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudFilerLocation> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/filer/${filerId}/location`);
  };

  /** Remove the filer from your Dedicated Cloud. */
  postFilerRemoveByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/filer/${filerId}/remove`);
  };

  /** Tasks associated with this Filer */
  getFilerTaskByServiceNameAndFilerId = (
    filerId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/filer/${filerId}/task`);
  };

  /** Get this object properties */
  getFilerTaskByServiceNameAndFilerIdAndTaskId = (
    filerId: number,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/task/${taskId}`
    );
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateFilerTaskMaintenanceExecutionDateByServiceNameAndFilerIdAndTaskId = (
    filerId: number,
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postFilerTaskResetTaskStateByServiceNameAndFilerIdAndTaskId = (
    filerId: number,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/filer/${filerId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Get filtered tasks associated with this Dedicated Cloud */
  getGlobalTasksByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/globalTasks`);
  };

  /** Get this object properties */
  getHcxByServiceName = (serviceName: string): Promise<DedicatedCloudHcx> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hcx`);
  };

  /** Check if VMware Hybrid Cloud Extension option can be disabled */
  checkHcxCanBeDisabledByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hcx/canBeDisabled`);
  };

  /** Check if VMware Hybrid Cloud Extension option can be enabled */
  checkHcxCanBeEnabledByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hcx/canBeEnabled`);
  };

  /** Disable VMware Hybrid Cloud Extension option */
  disableHcxByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hcx/disable`);
  };

  /** Enable VMware Hybrid Cloud Extension option */
  enableHcxByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hcx/enable`);
  };

  /** Get this object properties */
  getHdsByServiceName = (serviceName: string): Promise<DedicatedCloudHds> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hds`);
  };

  /** Check if Hds option can be disabled */
  checkHdsCanBeDisabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hds/canBeDisabled`);
  };

  /** Check if Hds option can be enabled */
  checkHdsCanBeEnabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hds/canBeEnabled`);
  };

  /** Disable Hds option */
  disableHdsByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hds/disable`);
  };

  /** Enable Hds option */
  enableHdsByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hds/enable`);
  };

  /** Get this object properties */
  getHipaaByServiceName = (serviceName: string): Promise<DedicatedCloudHipaa> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hipaa`);
  };

  /** Check if Hipaa option can be disabled */
  checkHipaaCanBeDisabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hipaa/canBeDisabled`);
  };

  /** Check if Hipaa option can be enabled */
  checkHipaaCanBeEnabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/hipaa/canBeEnabled`);
  };

  /** Disable Hipaa option */
  disableHipaaByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hipaa/disable`);
  };

  /** Enable Hipaa option */
  enableHipaaByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/hipaa/enable`);
  };

  /** Ip Blocks attached to this Dedicated Cloud */
  getIpByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/ip`);
  };

  /** Get this object properties */
  getIpByServiceNameAndNetwork = (
    network: string,
    serviceName: string
  ): Promise<DedicatedCloudIp> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/ip/${network}`);
  };

  /** List details about this IP Block */
  listIpDetailsByServiceNameAndNetwork = (
    network: string,
    serviceName: string
  ): Promise<DedicatedCloudIpDetails[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/ip/${network}/details`);
  };

  /** Tasks associated with this IP Block */
  getIpTaskByServiceNameAndNetwork = (network: string, serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/ip/${network}/task`);
  };

  /** Get this object properties */
  getIpTaskByServiceNameAndNetworkAndTaskId = (
    network: string,
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/ip/${network}/task/${taskId}`);
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateIpTaskMaintenanceExecutionDateByServiceNameAndNetworkAndTaskId = (
    network: string,
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/ip/${network}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postIpTaskResetTaskStateByServiceNameAndNetworkAndTaskId = (
    network: string,
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/ip/${network}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Get the new Prices for your Dedicated Cloud */
  getNewPricesByServiceName = (serviceName: string): Promise<DedicatedCloudResourceNewPrices> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/newPrices`);
  };

  /** Get this object properties */
  getNsxByServiceName = (serviceName: string): Promise<DedicatedCloudNsx> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/nsx`);
  };

  /** Check if Nsx option can be disabled */
  checkNsxCanBeDisabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/nsx/canBeDisabled`);
  };

  /** Check if Nsx option can be enabled */
  checkNsxCanBeEnabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/nsx/canBeEnabled`);
  };

  /** Disable Nsx option */
  disableNsxByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/nsx/disable`);
  };

  /** Enable Nsx option */
  enableNsxByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/nsx/enable`);
  };

  /** Get this object properties */
  getNsxtByServiceName = (serviceName: string): Promise<DedicatedCloudNsxt> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/nsxt`);
  };

  /** Order a new hourly Filer mounted in every Datacenter of a given Dedicated Cloud */
  postOrderNewFilerHourlyByServiceName = (
    serviceName: string,
    body: { name: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/orderNewFilerHourly`, body);
  };

  /** Get the countries you can select in /order/dedicatedCloud/{serviceName}/ip */
  getOrderableIpCountriesByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudIpCountriesEnum[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/orderableIpCountries`);
  };

  /** Get the current password policy for your Dedicated Cloud */
  getPasswordPolicyByServiceName = (serviceName: string): Promise<DedicatedCloudPasswordPolicy> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/passwordPolicy`);
  };

  /** Get this object properties */
  getPcidssByServiceName = (serviceName: string): Promise<DedicatedCloudPciDss> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/pcidss`);
  };

  /** Check if PCI-DSS option can be disabled */
  checkPcidssCanBeDisabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/pcidss/canBeDisabled`);
  };

  /** Check if PCI-DSS option can be enabled */
  checkPcidssCanBeEnabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/pcidss/canBeEnabled`);
  };

  /** Disable PCI-DSS option */
  disablePcidssByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/pcidss/disable`);
  };

  /** Enable PCI-DSS option */
  enablePcidssByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/pcidss/enable`);
  };

  /** Reset all triggered alarms on PCC */
  postResetTriggeredAlarmByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/resetTriggeredAlarm`);
  };

  /** Robots that can run on this Dedicated Cloud */
  getRobotByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/robot`);
  };

  /** Get this object properties */
  getRobotByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<DedicatedCloudRobot> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/robot/${name}`);
  };

  /** Get this object properties */
  getSecurityOptionsByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudSecurityOption> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/securityOptions`);
  };

  /** Show compatibility matrix of security options with your Dedicated Cloud */
  getSecurityOptionsCompatibilityMatrixByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudSecurityOptionCompatibilityMatrixEntry[]> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/securityOptions/compatibilityMatrix`
    );
  };

  /** Show the dependencies tree of a security option */
  getSecurityOptionsDependenciesTreeByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudSecurityOptionDependenciesTree> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/securityOptions/dependenciesTree`
    );
  };

  /** List pending security options enabling on your Dedicated Cloud */
  listSecurityOptionsPendingOptionsByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudSecurityOptionSecurityOptionEnum[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/securityOptions/pendingOptions`);
  };

  /** Resume enabling of pending security options on your Dedicated Cloud */
  postSecurityOptionsResumePendingEnablingByServiceName = (
    serviceName: string,
    body: { option: DedicatedCloudSecurityOptionSecurityOptionEnum }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/securityOptions/resumePendingEnabling`,
      body
    );
  };

  /** Get this object properties */
  getServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateServiceInfosByServiceName = (serviceName: string, body: ServicesService): Promise<void> => {
    return this.ovh.request('PUT', `/dedicatedCloud/${serviceName}/serviceInfos`, body);
  };

  /** Retrieve the service pack informations */
  getServicePackByServiceName = (serviceName: string): Promise<DedicatedCloudServicePackStatus> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/servicePack`);
  };

  /** Service Pack compliant with the current Dedicated Cloud */
  getServicePacksByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/servicePacks`);
  };

  /** Get this object properties */
  getServicePacksByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<DedicatedCloudServicePack> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/servicePacks/${name}`);
  };

  /** Tasks associated with this Dedicated Cloud */
  getTaskByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/task`);
  };

  /** Get this object properties */
  getTaskByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/task/${taskId}`);
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateTaskMaintenanceExecutionDateByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postTaskResetTaskStateByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Terminate your service */
  postTerminateByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/terminate`);
  };

  /** Ip allowed to bypass the two factor authentication on this Dedicated Cloud management interface */
  getTwoFAWhitelistByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/twoFAWhitelist`);
  };

  /** Add a whitelisted ip on the two factor authentication */
  addTwoFAWhitelistByServiceName = (
    serviceName: string,
    body: { description: string; ip: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/twoFAWhitelist`, body);
  };

  /** Remove a whitelisted ip on the two factor authentication */
  deleteTwoFAWhitelistByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('DELETE', `/dedicatedCloud/${serviceName}/twoFAWhitelist/${id}`);
  };

  /** Get this object properties */
  getTwoFAWhitelistByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<DedicatedCloudTwoFAWhitelist> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/twoFAWhitelist/${id}`);
  };

  /** Change Dedicated Cloud Two factor authentication whitelist properties */
  updateTwoFAWhitelistPropertiesByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: { description?: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/twoFAWhitelist/${id}/changeProperties`,
      body
    );
  };

  /** Upgrade your hypervisor to the next released version */
  postUpgradeHypervisorByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/upgradeHypervisor`);
  };

  /** Upgrade your vCenter to the next released version */
  postUpgradeVcenterByServiceName = (
    serviceName: string,
    body: { release?: DedicatedCloudReleaseEnum }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/upgradeVcenter`, body);
  };

  /** Dedicated Cloud users */
  getUserByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user`);
  };

  /** Create a new User in your Dedicated Cloud */
  createUserByServiceName = (
    serviceName: string,
    body: {
      canAddRessource?: boolean;
      canManageRights?: boolean;
      email?: string;
      encryptionRight?: boolean;
      expirationDate?: Date;
      firstName?: string;
      lastName?: string;
      name: string;
      networkRole?: DedicatedCloudRightNetworkRoleEnum;
      nsxRight?: boolean;
      password?: string;
      phoneNumber?: string;
      receiveAlerts?: boolean;
      right?: DedicatedCloudRightRightEnum;
      tokenValidator?: boolean;
      vmNetworkRole?: DedicatedCloudRightVmNetworkRoleEnum;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/user`, body);
  };

  /** Remove a given user from your Dedicated Cloud */
  deleteUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('DELETE', `/dedicatedCloud/${serviceName}/user/${userId}`);
  };

  /** Get this object properties */
  getUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudUser> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user/${userId}`);
  };

  /** Change Dedicated Cloud user password */
  updateUserPasswordByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: { password?: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/changePassword`,
      body
    );
  };

  /** Change Dedicated Cloud user properties */
  updateUserPropertiesByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: {
      canManageIpFailOvers?: boolean;
      canManageNetwork?: boolean;
      canManageRights?: boolean;
      email?: string;
      encryptionRight?: boolean;
      firstName?: string;
      fullAdminRo?: boolean;
      lastName?: string;
      nsxRight?: boolean;
      phoneNumber?: string;
      receiveAlerts?: boolean;
      tokenValidator?: boolean;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/changeProperties`,
      body
    );
  };

  /** Confirm phone number for user */
  confirmUserPhoneNumberByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: { token: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/confirmPhoneNumber`,
      body
    );
  };

  /** Disable the given Dedicated Cloud user  */
  disableUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/user/${userId}/disable`);
  };

  /** Enable the given Dedicated Cloud user  */
  enableUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/user/${userId}/enable`);
  };

  /** Get Metrics Token to query vScope Graphs data  */
  postUserMetricsTokenByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudMetricsToken> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/user/${userId}/metricsToken`);
  };

  /** User rights on an object */
  getUserObjectRightByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user/${userId}/objectRight`);
  };

  /** Add a new object right to user in datacenter on Dedicated Cloud */
  addUserObjectRightByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: {
      propagate?: boolean;
      right: DedicatedCloudRightRightEnum;
      type: DedicatedCloudRightUserObjectRightTypeEnum;
      vmwareObjectId: string;
    }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/objectRight`,
      body
    );
  };

  /** Remove an object right from user in datacenter on Dedicated Cloud */
  deleteUserObjectRightByServiceNameAndUserIdAndObjectRightId = (
    objectRightId: number,
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'DELETE',
      `/dedicatedCloud/${serviceName}/user/${userId}/objectRight/${objectRightId}`
    );
  };

  /** Get this object properties */
  getUserObjectRightByServiceNameAndUserIdAndObjectRightId = (
    objectRightId: number,
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudObjectRight> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/user/${userId}/objectRight/${objectRightId}`
    );
  };

  /** User rights in a given Datacenters */
  getUserRightByServiceNameAndUserId = (serviceName: string, userId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user/${userId}/right`);
  };

  /** Get this object properties */
  getUserRightByServiceNameAndUserIdAndRightId = (
    rightId: number,
    serviceName: string,
    userId: number
  ): Promise<DedicatedCloudRight> => {
    return this.ovh.request(
      'GET',
      `/dedicatedCloud/${serviceName}/user/${userId}/right/${rightId}`
    );
  };

  /** Alter this object properties */
  updateUserRightByServiceNameAndUserIdAndRightId = (
    rightId: number,
    serviceName: string,
    userId: number,
    body: DedicatedCloudRight
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'PUT',
      `/dedicatedCloud/${serviceName}/user/${userId}/right/${rightId}`,
      body
    );
  };

  /** Tasks associated with this User */
  getUserTaskByServiceNameAndUserId = (serviceName: string, userId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user/${userId}/task`);
  };

  /** Get this object properties */
  getUserTaskByServiceNameAndUserIdAndTaskId = (
    serviceName: string,
    taskId: number,
    userId: number
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/user/${userId}/task/${taskId}`);
  };

  /** Change the execution date of a maintenance. Works only if task type is maintenance and if it has not started yet. */
  updateUserTaskMaintenanceExecutionDateByServiceNameAndUserIdAndTaskId = (
    serviceName: string,
    taskId: number,
    userId: number,
    body: { executionDate: Date }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/task/${taskId}/changeMaintenanceExecutionDate`,
      body
    );
  };

  /** Restart task in error. */
  postUserTaskResetTaskStateByServiceNameAndUserIdAndTaskId = (
    serviceName: string,
    taskId: number,
    userId: number,
    body: { reason: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/user/${userId}/task/${taskId}/resetTaskState`,
      body
    );
  };

  /** Get available upgrade for your vCenter */
  getVcenterVersionByServiceName = (serviceName: string): Promise<DedicatedCloudVcenter> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vcenterVersion`);
  };

  /** Get this object properties */
  getVendorByServiceName = (serviceName: string): Promise<DedicatedCloudVendor> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vendor`);
  };

  /** Get available object types */
  postVendorObjectTypeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vendor/objectType`);
  };

  /** Get ovh id from object type */
  postVendorOvhIdByServiceName = (
    serviceName: string,
    body: { objectType: DedicatedCloudVendorObjectTypeEnum; vendorId: string }
  ): Promise<DedicatedCloudVendorOvhId> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vendor/ovhId`, body);
  };

  /** Dedicated Cloud vlans */
  getVlanByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vlan`);
  };

  /** Get this object properties */
  getVlanByServiceNameAndVlanId = (
    serviceName: string,
    vlanId: number
  ): Promise<DedicatedCloudVlan> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vlan/${vlanId}`);
  };

  /** Get this object properties */
  getVmEncryptionByServiceName = (serviceName: string): Promise<DedicatedCloudVMEncryption> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vmEncryption`);
  };

  /** VM Encryption KMS linked to this Dedicated Cloud */
  getVmEncryptionKmsByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vmEncryption/kms`);
  };

  /** Add a new option user access */
  addVmEncryptionKmsByServiceName = (
    serviceName: string,
    body: { description?: string; ip: string; sslThumbprint: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vmEncryption/kms`, body);
  };

  /** Remove an option user access */
  deleteVmEncryptionKmsByServiceNameAndKmsId = (
    kmsId: number,
    serviceName: string
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('DELETE', `/dedicatedCloud/${serviceName}/vmEncryption/kms/${kmsId}`);
  };

  /** Get this object properties */
  getVmEncryptionKmsByServiceNameAndKmsId = (
    kmsId: number,
    serviceName: string
  ): Promise<DedicatedCloudVMEncryptionAccessNetwork> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vmEncryption/kms/${kmsId}`);
  };

  /** Change option user access properties */
  updateVmEncryptionKmsPropertiesByServiceNameAndKmsId = (
    kmsId: number,
    serviceName: string,
    body: { description?: string; sslThumbprint: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request(
      'POST',
      `/dedicatedCloud/${serviceName}/vmEncryption/kms/${kmsId}/changeProperties`,
      body
    );
  };

  /** This Dedicated Cloud vrack */
  getVrackByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vrack`);
  };

  /** remove this dedicatedCloud (VmNetwork) from this vrack */
  deleteVrackByServiceNameAndVrack = (serviceName: string, vrack: string): Promise<VrackTask> => {
    return this.ovh.request('DELETE', `/dedicatedCloud/${serviceName}/vrack/${vrack}`);
  };

  /** Get this object properties */
  getVrackByServiceNameAndVrack = (
    serviceName: string,
    vrack: string
  ): Promise<VrackDedicatedCloud> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vrack/${vrack}`);
  };

  /** Get this object properties */
  getVropsByServiceName = (serviceName: string): Promise<DedicatedCloudVrops> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vrops`);
  };

  /** Check if vRealize Operations option can be disabled */
  checkVropsCanBeDisabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vrops/canBeDisabled`);
  };

  /** Check if vRealize Operations option can be enabled */
  checkVropsCanBeEnabledByServiceName = (
    serviceName: string
  ): Promise<DedicatedCloudOptionCompatibility> => {
    return this.ovh.request('GET', `/dedicatedCloud/${serviceName}/vrops/canBeEnabled`);
  };

  /** Disable vRealize Operations option */
  disableVropsByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vrops/disable`);
  };

  /** Enable vRealize Operations option */
  enableVropsByServiceName = (serviceName: string): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vrops/enable`);
  };

  /** Request vRealize Operations Manager upgrade */
  postVropsUpgradeByServiceName = (
    serviceName: string,
    body: { version?: string }
  ): Promise<DedicatedCloudTask> => {
    return this.ovh.request('POST', `/dedicatedCloud/${serviceName}/vrops/upgrade`, body);
  };
}

export { DedicatedCloudHandler };
